export var RuleAlias;
(function (RuleAlias) {
    RuleAlias["MANAGE_ALL"] = "manageAll";
    RuleAlias["READ_ALL"] = "readAll";
    RuleAlias["USER_READ"] = "userRead";
    RuleAlias["USER_CREATE"] = "userCreate";
    RuleAlias["USER_UPDATE"] = "userUpdate";
    RuleAlias["PROTOCOL_READ"] = "protocolRead";
    RuleAlias["PROTOCOL_CREATE"] = "protocolCreate";
    RuleAlias["PROTOCOL_UPDATE"] = "protocolUpdate";
    RuleAlias["PROTOCOL_DELETE"] = "protocolDelete";
    RuleAlias["AUDIT_LOG_READ"] = "auditLogRead";
    RuleAlias["CLIENT_DEVICE_READ"] = "clientDeviceRead";
    RuleAlias["CLIENT_DEVICE_DELETE"] = "clientDeviceDelete";
    RuleAlias["MANAGE_WIZARD"] = "manageWizard";
    RuleAlias["APPROVAL_READ"] = "approvalRead";
    RuleAlias["FIRST_APPROVAL_CREATE"] = "firstApprovalCreate";
    RuleAlias["SECOND_APPROVAL_CREATE"] = "secondApprovalCreate";
    RuleAlias["CREW_LIST_READ"] = "crewListRead";
    RuleAlias["CREW_LIST_CREATE"] = "crewListCreate";
    RuleAlias["CREW_LIST_UPDATE"] = "crewListUpdate";
    RuleAlias["CREW_LIST_DELETE"] = "crewListDelete";
    RuleAlias["RESPONSIBILITY_READ"] = "responsibilityRead";
    RuleAlias["RESPONSIBILITY_CREATE"] = "responsibilityCreate";
    RuleAlias["RESPONSIBILITY_UPDATE"] = "responsibilityUpdate";
    RuleAlias["RESPONSIBILITY_DELETE"] = "responsibilityDelete";
    RuleAlias["EQUIPMENT_READ"] = "equipmentRead";
    RuleAlias["EQUIPMENT_CREATE"] = "equipmentCreate";
    RuleAlias["EQUIPMENT_UPDATE"] = "equipmentUpdate";
    RuleAlias["EQUIPMENT_DELETE"] = "equipmentDelete";
    RuleAlias["SYSTEM_UPDATE_CREATE"] = "systemUpdateCreate";
    RuleAlias["LICENSE_CREATE"] = "licenseCreate";
    RuleAlias["SYSTEM_SETTINGS_READ"] = "systemSettingsRead";
    RuleAlias["SHIP_NETWORK_SETTINGS_READ"] = "shipNetworkSettingsRead";
    RuleAlias["SHIP_NETWORK_SETTINGS_UPDATE"] = "shipNetworkSettingsUpdate";
    RuleAlias["LWE_NETWORK_SETTINGS_READ"] = "lweNetworkSettingsRead";
    RuleAlias["LWE_NETWORK_SETTINGS_UPDATE"] = "lweNetworkSettingsUpdate";
    RuleAlias["AIS_SETTINGS_READ"] = "aisSettingsRead";
    RuleAlias["AIS_SETTINGS_UPDATE"] = "aisSettingsUpdate";
    RuleAlias["AUTOMATED_RECORDING_SETTINGS_READ"] = "automatedRecordingSettingsRead";
    RuleAlias["AUTOMATED_RECORDING_SETTINGS_UPDATE"] = "automatedRecordingSettingsUpdate";
    RuleAlias["SYSTEM_TIME_SETTINGS_READ"] = "systemTimeSettingsRead";
    RuleAlias["SYSTEM_TIME_SETTINGS_UPDATE"] = "systemTimeSettingsUpdate";
    RuleAlias["RESET_CLOUD_CONNECTION_CREATE"] = "resetCloudConnectionCreate";
    RuleAlias["SELF_CHECK_READ"] = "selfCheckRead";
    RuleAlias["VOYAGES_UPDATE"] = "voyagesUpdate";
    RuleAlias["VOYAGES_READ"] = "voyagesRead";
    RuleAlias["VOYAGES_CREATE"] = "voyagesCreate";
    RuleAlias["VESSEL_PARTICULARS_UPDATE"] = "vesselParticularsUpdate";
    RuleAlias["VESSEL_PARTICULARS_READ"] = "vesselParticularsRead";
    RuleAlias["SOUNDING_SPOT_UPDATE"] = "soundingSpotUpdate";
    RuleAlias["SOUNDING_SPOT_READ"] = "soundingSpotRead";
    RuleAlias["SOUNDING_SPOT_CREATE"] = "soundingSpotCreate";
    RuleAlias["SOUNDING_SPOT_DELETE"] = "soundingSpotDelete";
    RuleAlias["ORDER_READ"] = "orderRead";
    RuleAlias["ORDER_CREATE"] = "orderCreate";
    RuleAlias["ORDER_UPDATE"] = "orderUpdate";
    RuleAlias["MANAGE_BOOK_CONFIGURATION"] = "manageBookConfiguration";
    RuleAlias["BACKUP_READ"] = "backupRead";
    RuleAlias["BACKUP_CREATE"] = "backupCreate";
    RuleAlias["LOGS_READ"] = "logsRead";
    RuleAlias["MANAGE_CHECKLIST_TYPE"] = "manageChecklistType";
    RuleAlias["INSTALLATION_WIZARD_READ"] = "installationWizardRead";
    RuleAlias["TLS_CERTIFICATE_CREATE"] = "TLSCertificateCreate";
    RuleAlias["TLS_CERTIFICATE_READ"] = "TLSCertificateRead";
    RuleAlias["TLS_CERTIFICATE_DELETE"] = "TLSCertificateDelete";
    RuleAlias["RESTART_CREATE"] = "RestartCreate";
})(RuleAlias || (RuleAlias = {}));
//# sourceMappingURL=RuleAlias.js.map